import ModalUpdateStatusCampaign from '@app/components/ModalUpdateStatusCampaign'
import DataGrid from '@app/components/organisms/DataGrid/DataGrid'
import { VOUCHER_STATUS } from '@app/constant/VoucherConstant'
import { VOUCHER_TYPE } from '@app/constant/VoucherTypeConstant'
import TextFieldInput from '@app/modules/Admin/Campaign/CampaignAddVoucher/TextFieldInput'
import { Inertia } from '@inertiajs/inertia'
import { InertiaLink } from '@inertiajs/inertia-react'
import VisibilityIcon from '@mui/icons-material/Visibility'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export default function CampaignAddVoucher({ vouchers, campaign }) {
  const { t } = useTranslation()
  const [dataSubmit, setDataSubmit] = useState({})
  const [errorData, setErrorData] = useState([])

  const { register, handleSubmit, getValues, setValue, reset } = useForm({
    defaultValues: {},
  })
  const onSubmit = (data, prop) => {
    const dataItem = prop?.selectedOriginalIds?.map((item) => data[item])
    let x = {}
    dataItem.forEach((item) => {
      const itemValue = {
        id: item.id,
        amount_codes: item.amount_codes,
        available_codes: item.available_codes,
        point: item.point,
        error: false,
      }
      if (VOUCHER_TYPE.PREMIUM === item.type && '' === item.amount_codes) {
        const error = {
          ...itemValue,
          error: true,
          errorMessage: {
            message: 'VALIDATE.REQUIRED_QUANTITY',
            min: item.limit_min,
            max: item.limit_max,
          },
        }
        x = { ...x, [item.id]: error }
      } else if (VOUCHER_TYPE.PREMIUM === item.type && !Number.isInteger(Number(item.amount_codes))) {
        const error = {
          ...itemValue,
          error: true,
          errorMessage: {
            message: 'VALIDATE.INTEGER_QUANTITY',
            min: item.limit_min,
            max: item.limit_max,
          },
        }
        x = { ...x, [item.id]: error }
      } else if (
        (VOUCHER_TYPE.PREMIUM === item.type && Number(item.amount_codes) > Number(item.limit_max)) ||
        (VOUCHER_TYPE.PREMIUM === item.type && Number(item.amount_codes) < Number(item.limit_min)) ||
        (VOUCHER_TYPE.PREMIUM === item.type && 0 >= Number(item.amount_codes))
      ) {
        const error = {
          ...itemValue,
          error: true,
          errorMessage: {
            message: 'VALIDATE.VALID_LIMIT_AMOUNT_CODES',
            min: item.limit_min,
            max: item.limit_max,
          },
        }
        x = { ...x, [item.id]: error }
      }
      if (0 > Number(item.point)) {
        const error = {
          ...itemValue,
          errorPoint: true,
          errorPointMessage: {
            message: 'VALIDATE.VALIDATE_POINT',
            number: 0,
          },
        }
        x = { ...x, [item.id]: { ...error, ...x[item.id] } }
      }
      if ('' === item.point) {
        const error = {
          ...itemValue,
          errorPoint: true,
          errorPointMessage: {
            message: 'VALIDATE.REQUIRED_POINT',
            number: 0,
          },
        }
        x = { ...x, [item.id]: { ...error, ...x[item.id] } }
      } else if (!Number.isInteger(Number(item.point))) {
        const error = {
          ...itemValue,
          errorPoint: true,
          errorPointMessage: {
            message: 'VALIDATE.INTEGER_POINT',
          },
        }
        x = { ...x, [item.id]: { ...error, ...x[item.id] } }
      }
    })
    setErrorData(x)
    if (0 === Object.keys(x).length && x.constructor === Object) {
      setDataSubmit(dataItem)
      setOpenModalConfirm(true)
    }
  }

  const [openModalConfirm, setOpenModalConfirm] = useState(false)
  const handleCloseModal = () => setOpenModalConfirm(false)

  return (
    <Grid container spacing={2} onSubmit={handleSubmit(onSubmit)}>
      <Grid item xs={12}>
        <DataGrid
          enableCheckboxColumn
          enableIndexColumn
          columns={[
            {
              id: 'name',
              Header: t('VOUCHER.NAME'),
              accessor: 'name',
              type: 'string',
            },
            {
              id: 'merchant_name',
              Header: t('VOUCHER.MERCHANT_NAME'),
              accessor: 'merchant_name',
              type: 'string',
              disableFilters: true,
            },
            {
              id: 'price',
              Header: t('VOUCHER.PRICE'),
              accessor: 'price',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'available_codes',
              Header: t('VOUCHERS.AVAILABLE_CODES'),
              accessor: 'available_codes',
              type: 'number',
              autoHide: true,
            },
            {
              id: 'expired_date',
              Header: t('VOUCHER.EXPIRED'),
              accessor: 'expired_date',
              type: 'dateTime',
              disableFilters: true,
            },
            {
              id: 'type',
              Header: t('VOUCHER.VOUCHER_TYPE'),
              accessor: ({ type }) => t(`CODES.${type.toUpperCase()}`),
              type: 'singleSelect',
              typeCategories: 'Type',
              options: [
                { value: VOUCHER_TYPE.STANDARD, name: t('VOUCHERS.STANDARD') },
                { value: VOUCHER_TYPE.PREMIUM, name: t('VOUCHERS.PREMIUM') },
              ],
            },
            {
              id: 'status',
              Header: t('VOUCHER.STATUS'),
              accessor: ({ status }) => t(`CODES.${status.toUpperCase()}`),
              type: 'singleSelect',
              options: [
                { value: VOUCHER_STATUS.ACTIVE, name: t('VOUCHERS.ACTIVE') },
                { value: VOUCHER_STATUS.IN_ACTIVE, name: t('VOUCHERS.INACTIVE') },
              ],
            },
            {
              id: 'actions',
              Header: t('VOUCHER.ACTION'),
              disableFilters: true,
              Cell: ({ row }) => (
                <IconButton
                  component={InertiaLink}
                  href={route('admin.vouchers.show', {
                    voucher: row.original.id,
                  })}
                >
                  <VisibilityIcon />
                </IconButton>
              ),
            },
            {
              id: 'quantity',
              Header: t('VOUCHER.QUANTITY'),
              disableFilters: true,
              Cell: ({ row }) => {
                const rowData = row.original
                const { id } = rowData
                return (
                  <TextFieldInput
                    campaign={campaign}
                    errorData={errorData}
                    field="amount_codes"
                    getValues={getValues}
                    id={id}
                    name={`${id}_amount_codes`}
                    register={register}
                    rowData={rowData}
                    setValue={setValue}
                  />
                )
              },
            },
            {
              id: 'point',
              Header: t('VOUCHER.POINT'),
              disableFilters: true,
              Cell: ({ row }) => {
                const rowData = row.original
                const { id } = rowData
                return (
                  <TextFieldInput
                    campaign={campaign}
                    errorData={errorData}
                    field="point"
                    getValues={getValues}
                    id={id}
                    name={`${id}_point`}
                    register={register}
                    rowData={rowData}
                    setValue={setValue}
                  />
                )
              },
            },
          ]}
          data={vouchers}
          params={{ campaign: campaign.id }}
          queries={{ campaign }}
          reset={reset}
          routeName="admin.campaigns.vouchers.add"
          setErrorData={setErrorData}
          toolbarActions={[
            (prop) => (
              <>
                <Button color="primary" size="small" variant="contained" onClick={() => onSubmit(getValues(), prop)}>
                  {t('BUTTON.ADD')}
                </Button>

                <ModalUpdateStatusCampaign
                  content={t('MODAL.ADD_VOUCHER_CAMPAIGN_CONTENT')}
                  handleCloseModal={handleCloseModal}
                  handleSubmit={async () => {
                    await Inertia.post(
                      route('admin.campaigns.vouchers.save', { campaign: campaign.id }),
                      dataSubmit,
                      {}
                    )
                    handleCloseModal()
                    prop.clear()
                    // localStorage.removeItem(`addVoucherCampaign_${campaign.id}`);
                  }}
                  openModalConfirm={openModalConfirm}
                  title={t('MODAL.ADD_VOUCHER_CAMPAIGN')}
                />
              </>
            ),
          ]}
        />
      </Grid>
    </Grid>
  )
}
